import { useCallback } from "react"

import { useParams } from "react-router-dom"

import { NavigationOrigins, useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { useExistingVerticalSign } from "../../hooks/queries/verticalSigning/useVerticalSignPoles"

export const VerticalSignPoleValidator = (props) => {
    const { children } = props

    const { road, code, signId: poleId } = useParams()
    const navigate = useNavigateWithSearchParams()

    const navigateBack = useCallback(() => {
        navigate(code ? `../${road}/${code ? `code/${code}` : ""}` : `../${road}`, { navigationOrigin: NavigationOrigins.NONE })
    }, [code, navigate, road])

    const existingVerticalSignPoleInCache = useExistingVerticalSign(poleId, navigateBack)

    if (!existingVerticalSignPoleInCache) {
        return null
    }

    return children
}